export const openUrlInPopup = (url: string) => window.open(url, 'popup', 'width=600,height=600');
